// extracted by mini-css-extract-plugin
export default {"container":"ProductList_container__Ls9eh","list":"ProductList_list__+t9ht","item":"ProductList_item__cYiy-"};